/**
 * Social (Marketing > Social): kleine lezers voor buiten de marketing-store.
 */
import { marketingFetch } from '../stores/marketing-store';

/** Aantal Instagram-voorstellen dat op goedkeuring wacht (sidebar-badge). */
export async function fetchSocialWachtrijCount(): Promise<number> {
  const uit = await marketingFetch<{ n: number }>('/api/marketing/social/posts?status=gerenderd&count=1');
  return uit.n ?? 0;
}
